import styled from 'styled-components';

export const StyledActivityTryFeedback = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  h3 {
    text-align: center;
    width: 100%;
    font-size: 22px;
    font-weight: bold;
  }

  .saving {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .feedback-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 40px;

    .action {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;

      p {
        text-align: center;
        font-size: 20px;
      }

      button {
        font-size: 20px;
        height: auto;
      }
    }
  }
`;
